import React, { useState } from 'react';
import "../Pages/Nav.css";
import { NavLink } from 'react-router-dom';

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar" aria-label="Main navigation">
      <div className="navbar-logo">MSA</div>
      
      <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
        <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
        <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
        <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
      </button>

      <ul className={`navLinks ${menuOpen ? 'active' : ''}`}>
        <li className="navItem">
          <NavLink 
            to="/home" 
            className={({ isActive }) => `navLink ${isActive ? "active" : ""}`}
          >
            Home
          </NavLink>
        </li>
        <li className="navItem">
          <NavLink 
            to="/contact" 
            className={({ isActive }) => `navLink ${isActive ? "active" : ""}`}
          >
            Contact
          </NavLink>
        </li>
        <li className="navItem">
          <NavLink 
            to="/about" 
            className={({ isActive }) => `navLink ${isActive ? "active" : ""}`}
          >
            About
          </NavLink>
        </li>
        <li className="navItem">
          <NavLink 
            to="/reservation" 
            className={({ isActive }) => `navLink ${isActive ? "active" : ""}`}
          >
            Reservation
          </NavLink>
        </li>
  
      </ul>
    </nav>
  );
};

export default Nav;
